import { commonQuotesService } from '@/services/quotes/common';
import { useQueries } from '@tanstack/react-query';

// Mesmos grupos dos cards: Total, Em digitação(1), Em Análise(17),
// Calculada(3), Encerrada(2,4,5).
const STATUS_KEYS = ['', '1', '17', '3', '2,4,5'] as const;

type StatusCountEntry = {
  status: string;
  total: number;
};

interface UseQuoteStatusCountsParams {
  partyCode?: string;
  productCode?: string;
  proposalDateFrom?: string;
  proposalDateTo?: string;
}

export function useQuoteStatusCounts({
  partyCode,
  productCode,
  proposalDateFrom,
  proposalDateTo,
}: UseQuoteStatusCountsParams = {}) {
  const results = useQueries({
    queries: STATUS_KEYS.map(status => ({
      queryKey: [
        'quotes-status-count',
        status,
        partyCode,
        productCode,
        proposalDateFrom,
        proposalDateTo,
      ],
      queryFn: async () => {
        const response = await commonQuotesService.getQuotes({
          pageSize: 1,
          pageNumber: 1,
          status,
          partyCode,
          productCode,
          proposalDateFrom,
          proposalDateTo,
        });
        if (!response.success || !response.data) return 0;
        return response.data.meta?.total ?? 0;
      },
      staleTime: 30_000,
    })),
  });

  const counts: StatusCountEntry[] = STATUS_KEYS.map((status, i) => ({
    status,
    total: results[i].data ?? 0,
  }));

  const isLoading = results.some(r => r.isLoading);

  return { counts, isLoading };
}
